import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=0987dbc8&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=0987dbc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987dbc8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiAccordionItem: require('/app/components/UI/UiAccordionItem.vue').default,UiAccordion: require('/app/components/UI/UiAccordion.vue').default})
